<template>
  <div class="search-form px-3">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset="onReset"
    >
      <div class="row nopads">
        <div
          class="col-sm-6"
          style="padding-top: 6px"
        >
          <span class="search-title">{{ $t('account.account') }}</span>
          <input
            id="name"
            v-model="name"
            class="form-control form-control-sm"
            type="text"

            autofocus
            :placeholder="$t('account.account')"
          >
        </div>
        <div
          class="col-sm-6"
          style="padding-right: calc(0.5rem + 4px);"
        >
          <span class="span-title">{{ $t('account.state') }}</span>
          <select
            id="type"
            v-model="state"
            class="form-select form-select-sm sm-3"
          >
            <option :value="null">
              {{ $t('account.select_state') }}
            </option>
            <option
              v-for="option in getAccountInUseStates()"
              :key="option.value"
              :value="option.value"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-12 button-container">
        <button
          type="reset"
          class="btn btn-danger form-button"
        >
          {{ $t('ins_report.clear') }}
        </button>
        <button
          type="submit"
          class="btn btn-primary form-button"
        >
          {{ $t('ins_report.search') }}
        </button>
      </div>
    </form>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {accountHelper} from "@/components/mixins/AccountMixin";

export default {
    name: 'AccountSearch',
    mixins: [restApi, accountHelper],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            state: null,
            name: null
        }
    },
    methods: {
        onSubmit: function () {
            let params = {}
            if (this.name) {
                params.name = this.name
            }
            if (this.state) {
                params.state = this.state
            }
            this.$emit('search', params)
        },

        onReset: function () {
            this.name = null
            this.state = null
        }
    }
}
</script>


